import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";
import { ILocation } from "@/apps/merchant3/models/ILocation";

export const lockupPostalCode = async (
  postalCode: string,
  countryCode: string
): Promise<AxiosResponse<ILocation>> => {
  return await jwtApiClient.get(M3_API().LOOKUP_POSTAL_CODE_LOCATION, {
    params: {
      postalCode: postalCode,
      countryCode: countryCode,
    },
  });
};

export default lockupPostalCode;
